import { Head } from "@inertiajs/react"
import { useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import DocumentForm from "./_form"

interface CaseRecord {
  id: number
  case_number: string
  display_name: string
}

interface DocumentType {
  id: number
  name: string
}

interface DocumentData {
  id: number
  bg_document_type_id: number | null
  title: string
  notes: string
  document_date: string
  filename: string | null
  significant: number
  on_reports: number
  is_public: number
  has_file: boolean
}

interface Props {
  case_record: CaseRecord
  document: DocumentData
  document_types: DocumentType[]
  errors?: Record<string, string[]>
}

export default function Edit({
  case_record,
  document: doc,
  document_types,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Cases", href: "/cases" },
    {
      title: case_record.display_name || case_record.case_number,
      href: `/cases/${case_record.id}`,
    },
    { title: "Documents", href: `/cases/${case_record.id}/documents` },
    {
      title: "Edit",
      href: `/cases/${case_record.id}/documents/${doc.id}/edit`,
    },
  ]

  const { data, setData, put, processing } = useForm({
    case_document: {
      bg_document_type_id: doc.bg_document_type_id,
      title: doc.title || "",
      notes: doc.notes || "",
      document_date: doc.document_date || "",
      significant: doc.significant || 0,
      on_reports: doc.on_reports || 0,
      is_public: doc.is_public || 0,
    },
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/cases/${case_record.id}/documents/${doc.id}`)
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit Document - ${case_record.case_number}`} />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">Edit Document</h1>
        <DocumentForm
          caseId={case_record.id}
          data={data.case_document}
          setData={(key, value) =>
            setData("case_document", { ...data.case_document, [key]: value })
          }
          errors={errors}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Update Document"
          documentTypes={document_types}
          currentFilename={doc.filename}
        />
      </div>
    </AppLayout>
  )
}
